const zarFormatter = new Intl.NumberFormat('en-ZA', {
  style: 'currency',
  currency: 'ZAR',
})

export function formatZAR(price: string): string {
  return zarFormatter.format(Number(price))
}

export function formatZARCents(cents: number): string {
  return zarFormatter.format(cents / 100)
}
